/**
 * @ngdoc directive
 * @name WebCoreModule.directive:wcValidationIndicator
 * @restrict A
 * @priority 1
 * @param {string=} wcValidationIndicator string defining the field identifier text that should be used in the validation message
 * @description
 * The wcValidationIndicator directive utilizes Angular's isValid and isRequired checks to display messages according to the error
 * state at the field level. The directive supports all form input types that are currently a part of the FRF.
 */

angular.module('WebCoreModule')
	.directive('wcValidationIndicator', ['_', '$translate', '$timeout', function(_, $translate, $timeout) {
		return {
			restrict: 'A',
			priority: 1,
			link: function(scope, elem, attr) { // jshint ignore:line
				//wrap in timeout of zero seconds to force a digest. This ensures nested directives finish before the indicator directive runs
				$timeout(function(){
					//fieldset is caps here thanks to the browser defining it that way
					if(!elem[0].form || elem[0].tagName === 'FIELDSET'){
						elem = $(elem).find('input');
					}

					var formName = elem[0].form.attributes.name.value;
					var ngFormObj = scope[formName];

					if(!ngFormObj) {
						//break out of isolate scope and then walk the tree for the form obj
						ngFormObj = scope.$parent[formName];
					}

					//modals use ctrl.form.formName instead of ctrl.formName
					//handle it here
					if(!ngFormObj && formName.indexOf(".") > -1) {
						formName = formName.split('.');
						ngFormObj = scope.$parent[formName[0]][formName[1]];
					}

					var elemName = elem[0].name;
					//sometimes the reset element will not carry the name attr (I'm looking at you, ui-select).
					//in this case, instead grab it off of the attr object that was passed in
					if(!elemName) {
						elemName = attr.name;
						//if this still isn't right, see if we are in a datatable
						if(!elemName) {
							if(attr.wcResponsiveTable === "") {
								elemName = 'wcResponsiveTable';
							}
						}
					}
					var elemCtrl;
					//need to select the controller in a different way if we are within a modal
					if(angular.isArray(formName)) {
						//take the controller's name off of the ng-model.
						//todo - if there's a better way to do this, DO IT!!
						var ctrlName = elem[0].attributes["ng-model"].nodeValue.split('.')[0];
						elemCtrl = scope.$parent[ctrlName];
					}
					else {
						elemCtrl = elem.controller();
					}
					var formGroup = $(elem).closest('.form-group')[0];
					//datatables will not be in a formgroup. add one and refer to it
					if(!formGroup || elemName === 'wcResponsiveTable'){
						formGroup = $('<div class="form-group col-xs-12"></div>').insertBefore('#'+elem.context.attributes.id.value);
					}

					var fieldNameTranslateString = attr.wcValidationIndicator;


					var errorTypes = {
						defaultMsg: 'Please add error message for {{n}}.',
						email: 'Please enter a valid email address.',
						minlength: 'Please enter at least {{n}} characters.',
						maxlength: 'You have entered more than {{n}} characters.',
						min: 'Please enter the number greater than {{n}}.',
						max: 'Please enter the number lesser than {{n}}.',
						minMaxRange: 'Please enter between {{min}} and {{max}}.',
						required: '{{fieldName}} is required.',
						tableRequired: '{{fieldName}} selection is required.',
						date: 'Please enter a valid date.',
						pattern: 'The pattern entered is incorrect.',
						number: 'Please enter a valid number.',
						url: 'Please enter a valid URL.',
						inValid: '{{fieldName}} is invalid.'
					};

					var errType, errorMessage, errorMessageDOM, n, min, max, validatorAttrs, errorMsgId, requiredText;

					var buildErrorMsg = function (errType) {
						if(validatorAttrs.length>0){
							if(ngFormObj[elemName].$error.hasOwnProperty('required')){
								errorMessage = $translate.instant(errorTypes.required, {fieldName:fieldNameTranslateString});
							}
							else {
								errorMessage = $translate.instant(errorTypes.inValid, {fieldName:fieldNameTranslateString});
							}
						}
						else {
							n =attr[errType];
							if((errType==='min'||errType==='max')&&(attr.min&&attr.max)) {
								errType = 'minMaxRange';
								min=attr.min;
								max=attr.max;
							}
							errorMessage = $translate.instant(errorTypes[errType], {n: n, fieldName:fieldNameTranslateString, min:min, max:max});
						}

					};


					//handy regex from http://stackoverflow.com/questions/8955533/javascript-jquery-split-camelcase-string-and-add-hyphen-rather-than-space
					var elemNameSnakeCase = elemName.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
					errorMsgId = elemNameSnakeCase + '-error';

					var buildErrorMsgDOM = function (errType) {
						buildErrorMsg(errType);
						errorMessageDOM = $('<span id="' + errorMsgId + '" class="label label-danger"><span class="glyphicon glyphicon-remove-sign"></span><span class="label-text">' + errorMessage + '</span></span>');
					};

					var watchListener = function() {
						//first, remove potential leftover messages.
						$(formGroup).find('#' + errorMsgId).remove();

						//when the validation error occurs, insert the error messages and mark the container
//						if(!ngFormObj[elemName].$valid && elemCtrl.isFormSubmitted) {
						if(!ngFormObj[elemName].$valid && ngFormObj.$submitted) {
							validatorAttrs = _.filter(_.keys(attr), function(item){
								return (item.indexOf('Validator') > -1);
							});

							var errorCases = _.toPairs(ngFormObj[elemName].$error);

							for(var i=0; i<errorCases.length; i++) {
								errType = errorCases[i][0];
								buildErrorMsgDOM(errType);
							}

							if(errType==='tableRequired') {
                                requiredText = $(formGroup).html();
                                $(formGroup).html(errorMessageDOM);
							}
							else {
                                $(formGroup).append(errorMessageDOM);
                            }
							$(formGroup).addClass('has-error');
						} else {
							$(formGroup).removeClass('has-error');
							$(formGroup).find('#' + errorMsgId).remove();
                            if(errType==='tableRequired') {
                            	$(formGroup).html(requiredText);
                            }
						}
					};

					scope.$watch(function(){
						return ngFormObj[elemName].$valid;
					}, function(){
						watchListener();
					});

					scope.$watch(function(){
						return ngFormObj.$submitted;
						//return elemCtrl.isFormSubmitted;
					}, function(){
						watchListener();
					});

					scope.$watch(function(){
						return ngFormObj[elemName].$error;
					}, function(){
						watchListener();
					}, true);
				},0);
			}
		};
	}]);
